import { useState } from "react";
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import useFetchIp from "../../Configs/useFetchIp";

const api_url = process.env.REACT_APP_API_URL;

function Register() {
    // If IP is not needed, we can remove this line:
    // const { ip } = useFetchIp(api_url); 

    const [formData, setFormData] = useState({
        name: "",
        yop: "",
        email: "",
        mobile: "",
        username: "",
        password: ""
    });

    const [loading, setLoading] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otpSentCancel, setOtpCancel] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Validate form data before submitting
    const validateForm = () => {
        if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
            Swal.fire("Error", "Please enter a valid email address.", "error");
            return false;
        }
        // Add other form validation checks here if necessary (e.g., phone number, password strength)
        return true;
    };

    const sendOTP = async (email) => {
        try {
            setOtpSent(false);
            const response = await fetch(`${api_url}/send_otp.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const result = await response.json();

            if (result.status === "success") {
                setOtpSent(true);
                Swal.fire({
                    title: 'OTP Sent',
                    text: 'An OTP has been sent to your email. Please check.',
                    icon: 'success',
                }).then(() => {
                    promptForOTP(email);
                });
            } else {
                Swal.fire("Error", result.message, "error");
                setLoading(false);
            }
        } catch (err) {
            Swal.fire("Error", `Failed to send OTP. ${err.message}`, "error");
            setLoading(false);
        }
    };

    const promptForOTP = (email) => {
        Swal.fire({
            icon: 'info',
            title: "Verify Email",
            input: "text",
            inputLabel: `Enter the OTP sent to ${email}`,
            inputPlaceholder: "Enter OTP here",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            confirmButtonText: "Verify OTP",
            backdrop: 'static',
            allowOutsideClick: false,
            preConfirm: (otp) => {
                if (!otp) {
                    Swal.showValidationMessage("Please enter OTP.");
                    return false;
                }
                return otp;
            },
            willClose: () => {
                setOtpCancel(false);
                setLoading(false);
                setOtpSent(false);
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const otp = result.value;
                verifyOTP(email, otp);
            } else {
                setOtpCancel(false);
                setLoading(false);
                setOtpSent(false);
            }
        });
    };

    const verifyOTP = async (email, otp) => {
        try {
            const response = await fetch(`${api_url}/verify_otp.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, otp }),
            });

            const result = await response.json();

            if (result.status === "success") {
                Swal.fire("Success", "Your email has been verified!", "success").then(() => {
                    Swal.fire("Success", "Registration completed!", "success").then((result) => {
                        if (result) {
                            window.location.href = '/login';
                        }
                    });
                });
            } else {
                Swal.fire({
                    title: 'Error',
                    text: result.message || 'Invalid OTP.',
                    icon: 'error',
                    confirmButtonText: 'Try Again'
                }).then((res) => {
                    if (res.isConfirmed) {
                        promptForOTP();
                    }
                });
            }
        } catch (err) {
            Swal.fire("Error", `Failed to verify OTP. ${err.message}`, "error");
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return; // Validate form before submission
        setLoading(true);
        try {
            const response = await fetch(`${api_url}/register.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (result.status === "success") {
                sendOTP(formData.email);
            } else {
                Swal.fire("Error", result.message, "error");
                setLoading(false);
            }
        } catch (err) {
            Swal.fire("Error", "Something went wrong.", "error");
            setLoading(false);
        }
    };

    return (
        <>
            {/* Your header and other components */}

            <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                <form onSubmit={handleSubmit}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="card col-md-12 login-card">
                                <div className="card-body">
                                    <h3 className="text-center">Register</h3><br />
                                    <div className="row justify-content-between g-3">
                                        {[
                                            { label: "Name", name: "name", type: "text" },
                                            { label: "Year of Passed out", name: "yop", type: "text" },
                                            { label: "Email Address", name: "email", type: "email" },
                                            { label: "Mobile", name: "mobile", type: "text" },
                                            { label: "Username", name: "username", type: "text" },
                                            { label: "Password", name: "password", type: "password" }
                                        ].map(({ label, name, type }) => (
                                            <div className="form-group col-md-6" key={name}>
                                                <label htmlFor={name}>{label}</label>
                                                <input
                                                    type={type}
                                                    className="form-control"
                                                    name={name}
                                                    id={name}
                                                    placeholder={label}
                                                    value={formData[name]}
                                                    onChange={handleChange}
                                                    aria-label={label}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="row justify-content-center g-3">
                                    <div className="d-flex col-md-12">
                                        <div className="form-group col-md-6 text-end">
                                            <span
                                                className="btn-login"
                                                style={{ display: 'none', textAlign: 'center', fontWeight: 'bold' }}
                                            >
                                                Registering...
                                            </span>
                                        </div>
                                        <div className="form-group col-md-6 text-end">
                                            <button
                                                type="submit"
                                                className="btn-login"
                                                id="Register-now"
                                                disabled={loading || otpSent || otpSentCancel}
                                            >
                                                <b>{loading || otpSent || otpSentCancel ? "Registering..." : "Register"}</b>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default Register;
